import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { IoService } from '../../../services/io.service';
import { Subscription } from 'rxjs';
import { MatTable } from '@angular/material';
import { rowsAnimation } from '../../../xanimations/animations';

const MARK_TABLE_MAX_ROWS = 3;
const MARK_TABLE_TIMEOUT = 45 * 1000;

export interface MarkingState {
  time: string;
  name: string;
  order: string;
  ok: string;
}

@Component({
  selector: 'app-dashboard-marking',
  templateUrl: './dashboard-marking.component.html',
  styleUrls: ['./dashboard-marking.component.css'],
  animations: [rowsAnimation]
})
export class DashboardMarkingComponent implements OnInit, OnDestroy {
  subDeviceLaserState: Subscription;
  subDeviceLaserMarking: Subscription;
  state: object = {machine_connected: false, laser_ready: false, safety_circuit_closed: false};
  triggerAlive: object;
  prod: boolean;
  prodName: string;
  stateText: string;
  stateIcon: string;
  stateSignal: string;
  imgName: string;

  displayedColumns: string[] = ['time', 'name', 'order', 'ok'];
  private markingStateSource: MarkingState[] = Array.from({length: MARK_TABLE_MAX_ROWS}, () => ({ time: '', name: '', order: '', ok: '' }));

  @ViewChild('dataTable') dataTable: MatTable<MarkingState>;

  constructor(private ioService: IoService) { }

  ngOnInit() {
    let markTimeout = null;
    this.imgName = 'offen_rot.png';
    this.subDeviceLaserState = this.ioService.getDeviceEvents('marking.state').subscribe(ev => {
      this.state = ev;
      console.log(ev);
      this.triggerAlive = {};
      if (markTimeout) { return; }
      this.imgName = ev.safety_circuit_closed ? 'zu_' : 'offen_';
      this.imgName += (ev.machine_connected && ev.laser_ready) ? 'gruen' : 'rot';
      this.imgName += '.png';
      if (!ev.safety_circuit_closed) {
        this.stateText = 'Sicherheitsschaltkreis offen';
        this.stateSignal = 'warn';
        this.stateIcon = 'check_circle';
      } else if (ev.machine_connected && ev.laser_ready) {
        this.stateText = 'Laser bereit';
        this.stateSignal = 'ok';
        this.stateIcon = 'check_circle';
      } else {
        this.stateText = 'Laser nicht bereit';
        this.stateSignal = 'nok';
        this.stateIcon = 'error';
      }
    });

    const onTimeoutBeforeDone = () => {
      markTimeout = null;
      this.prod = false;
      this.imgName = 'zu_gruen.png';
      const s: MarkingState = this.markingStateSource[0];
      s.ok = 'NOT OK';
      s.order = '';
      this.dataTable.renderRows();
      console.log('START timeout');
    };

    const addMarkingState = m => {
      const time = (new Date(m.t - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 19).replace('T', ' ');
      const markingState: MarkingState = { time, name: m.name, order: m.orderNo, ok: 'pending'};
      this.markingStateSource.unshift(markingState);
      this.markingStateSource.length = Math.min(this.markingStateSource.length, MARK_TABLE_MAX_ROWS);
      this.dataTable.renderRows();
    };
    const changeMarkingState = m => {
      const ms: MarkingState = this.markingStateSource.find(s => m.orderNo === s.order);
      if (ms) {
        ms.ok = m.stage;
        this.dataTable.renderRows();
        console.log('START confirmed');
      } else {
        console.log('NOT FOUND' + m.orderNo);
      }
    };

    this.subDeviceLaserMarking = this.ioService.getDeviceEvents('marking.mark').subscribe(m => {
      console.log(m);
      this.triggerAlive = {};
      switch (m.stage) {
        case 'START':
          console.log('START', m.name);
          this.prodName = m.name;
          this.prod = true;
          this.imgName = 'zu_laser.png';
          this.stateText = 'Produziere "' + m.name + '"';
          this.stateSignal = 'ok';
          this.stateIcon = 'grade';
          addMarkingState(m);
          if (markTimeout) {
            console.warn('START too early');
            clearInterval(markTimeout);
            markTimeout = null;
          }
          markTimeout = setTimeout(onTimeoutBeforeDone, MARK_TABLE_TIMEOUT);
          break;
        case 'ERROR':
        case 'DONE':
          if (markTimeout) {  // regular confirmation
            this.prod = false;
            this.imgName = 'zu_gruen.png';
            this.stateText = 'Laser bereit';
            this.stateSignal = 'ok';
            this.stateIcon = 'check_circle';
            changeMarkingState(m);
          } else { // DONE without a previous start
            console.log('DONE without START');
          }
          clearInterval(markTimeout);
          markTimeout = null;
          break;
        default:
          console.log('?????');
          this.prod = false;
          this.imgName = 'zu_gruen.png';
          this.stateText = 'Laser bereit';
          this.stateSignal = 'ok';
          this.stateIcon = 'check_circle';
      }
    });
  }

  ngOnDestroy() {
    if (this.subDeviceLaserState) { this.subDeviceLaserState.unsubscribe(); }
    if (this.subDeviceLaserMarking) { this.subDeviceLaserMarking.unsubscribe(); }
  }

}
